export enum LocalStorageKeys {
  SCREEN = 'SCREEN',
}
